import BaseModel from '@/utils/store/BaseModel'
import Collection from '@/store/models/collections/Collection'
import CollectionMember from '@/store/models/collections/CollectionMember'

class User extends BaseModel {
  static entity = 'users'

  static fields() {
    return {
      ...super.fields(),
      username: this.string().nullable(),
      email: this.string().nullable(),
      avatar: this.string().nullable(),
      deviceId: this.string().nullable(),
      createdAt: this.string().nullable(),
      importCredits: this.number(0),
      // account-wide item total (bookmarks + notes) in the private collection,
      // supplied by the backend /me payload; used to gate the in-app rating
      // prompt. Null until the backend sends it.
      itemsCount: this.number(null).nullable(),
      //
      emailVerified: this.boolean(false),
      verified: this.boolean(false),
      mfaActive: this.boolean(false),
      hasPassword: this.boolean(false),
      collectionId: this.string().nullable(),
      // relationships
      collections: this.belongsToMany(Collection, CollectionMember, 'userId', 'collectionId'),
    }
  }

  get isDeviceAccount() {
    return !!this.deviceId && !this.email
  }

  get isFullAccount() {
    return !this.isDeviceAccount
  }

  get isVerifiedAccount() {
    return this.verified
  }

  get avatarUrl() {
    if (!this.avatar) return null
    return `${CONFIG.cdnUrl}/${this.avatar}?class=avatar`
  }
}

export default User
